module.exports = __webpack_public_path__ + "img/clothing176.58df935d.jpg";